module.exports = {
  table: {
    index: 'index',
    time: '操作时间',
    remark: '变更信息',
    title: '多值选择',
    name: '数值',
  },
  error: {
    network: '请求错误，未找到请求资源。',
    timeout: '请求超时，请联系管理员。',
    clickError: '抱歉，暂未找到执行方法',
  },
  login: {
    title: 'Login Form',
    logIn: 'Log in',
    usernameNotEmpty: 'User name cannot be empty',
    passwordNotEmpty: 'Password cannot be empty',
    verificationNotEmpty: 'Verification code cannot be empty',
    username: 'Username',
    password: 'Password',
    verificationCode: 'Verification code',
    forget: 'Forget your password and ask for help?',
    changePassword: 'ChangePassword',
    userAccount: 'UserAccount',
    beforePassword: 'OriginalPassword',
    newPassword: 'NewPassword',
    userAccountEmpty: 'The account cannot be empty',
    beforePasswordEmpty: 'The original password cannot be null',
    newPasswordEmpty: 'The new password cannot be empty',
    newPasswordEmptyOne: 'The new password has a minimum length of 8 digits',
    newPasswordEmptyTwo: 'The new password must contain  letters and  Numbers',
  },
  search: {
    search: 'Search',
    reset: 'Reset',
    packUp: 'Pack up',
    spread: 'Spread',
    input: 'Please input ',
    choose: 'Please choose ',
    to: 'To',
    start: 'Start date',
    end: 'End date',
    nosearchError: 'Please select at least one query',
  },
  confirm: {
    delete: 'Confirm delete data?',
    content: 'Confirm to delete this record?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    deleteCancelled: 'Delete cancelled',
    forbid: '禁用数据？',
    forbidContent: '是否确认禁用？',
    lift: '启用数据？',
    liftContent: '是否确认启用？',
    repeatContent: '该数据可能存在',
    repeat: '点击查看详情',
    remove: '放弃数据？',
    removeContent: '是否确认放弃？',
    removeSend: '取消发送？',
    removeSendContent: '是否确认取消发送？',
    revert: '撤销数据？',
    revertContent: '是否确认撤销数据？',
    submit: '提交审批？',
    removeSubmit: '是否确认提交审批？',
  },
  alert: {
    error: 'Operation failed!',
    confirm: 'Confirm',
    save: '保存',
    submit: '提交',
  },
  message: {
    success: 'Operation succeeded!',
    cancle: '删除操作已取消',
  },
  dialog: {
    save: '保 存',
    submit: '提 交',
    confirm: '确 定',
    send: '发送',
    cancel: '取 消',
  },
  fix: {
    column: '固定列不可以拖动',
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有',
  },
  import: {
    importTitle: '导入数据',
    chooseFile: '选择文件',
    submitImport: '开始导入',
    importType: '上传文件只能是 xls、xlsx格式!',
    importLimit: '上传文件大小不能超过 20MB!',
    importTips: '只能上传xls/xlsx文件，且不超过20M',
    importSuccess: '导入成功',
  },
  xTable: {
    insert: '新增',
    delete: '删除',
    save: '保存',
    disable: '禁用',
    inabled: '启用',
    noSelectData: '请至少选择一条数据！',
    onlyOneSelect: '只能选择一条数据',
    onlyOneChange: '只能增加一行数据',
    saveNoData: '请至少选择一条产品',
    justOneSelectData: '当前明细行仅一条数据，不可删除',
    oneSelectData: '请选择一条数据！',
    disableDel: '当前数据已经被后续引用，不能删除',
    disableDelStatus: '的合同不能删除',
    toolbar: {
      custom: '自定义列',
      allTitle: '全选/取消',
      customAll: '全部',
    },
  },
  functionBtn: {
    save: '保存',
    commit: '提交',
    approval: '提交审批',
    edit: '修改',
    disable: '禁用',
    inable: '解禁用',
    delete: '删除',
    quit: '放弃',
    revert: '撤销',
    copy: '复制',
    print: '打印',
    withdraw: '撤回',
    return: '退回',
    writeOff: '冲销',
  },
};
